<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <div class="container">
        <Activation />
        <b-form @submit.prevent="submitFrom">
            <b-row class="head-box text-center">
                <b-col cols="12" md="6" class="inner-header-box">
                    <b-icon icon="envelope"></b-icon> support@culturesquare.com
                </b-col>
                <b-col cols="12" md="6" class="inner-header-box">
                    <b-icon icon="telephone"></b-icon> +1(445).777.4747
                </b-col>
            </b-row>
            <b-row class="form-container">
                <b-form-group class="col-md-6 mb-3" label-for="name">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="person"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" required v-model="contactData.sender_name" placeholder="Full Name"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label-for="email">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="envelope"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" required v-model="contactData.email" placeholder="Email"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label-for="Phone">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="telephone"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" v-model="contactData.phone" placeholder="Phone"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label-for="Subject">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="envelope"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" required v-model="contactData.subject" placeholder="Subject"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="col-md-12 mt-2 mb-4" label-for="input-1">
                    <textarea rows="7" required v-model="contactData.content" placeholder="Message" class="form-control"></textarea>
                </b-form-group>
                <b-form-group class="col-md-12 mt-2 mb-4">
                    <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey">
                    </vue-recaptcha>
                </b-form-group>
                <b-form-group class="desktop col-md-12 mb-3" label-for="input-1">
                    <button class="float-right btn btn-warning">{{btnText}}
                        <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                </b-form-group>
                <b-form-group class="mobile col-md-12 mb-3" label-for="input-1">

                    <button class="btn btn-warning">{{btnText}}
                        <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>

                </b-form-group>
            </b-row>
        </b-form>
    </div>
    <Footer />

</div>
</template>

<script>
import {
    VueRecaptcha
} from 'vue-recaptcha';
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import axios from "axios";
import {
    getBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl();
export default {
    name: "contact-us",
    data: function () {
        return {
            headerText: "Get in",
            headerTextEmpahasis: "Touch?",
            subText: "Find answers to your curiosity from out esteemed team.",
            fadedText: "contact",
            btnText: 'Send Message',
            sitekey: process.env.VUE_APP_RECAPTCHA_LIVE,
            contactData: {
                sender_name: '',
                email: '',
                phone: '',
                subject: '',
                content: ''
            }
        }
    },
    components: {
        VueRecaptcha,
        Header,
        BodyLinks,
        BlackHeaderRight,
        BlackHeaderMobile,
        Activation,
        Footer

    },
    methods: {
        async submitFrom() {
            this.$refs.invisibleRecaptcha.execute()
        },
        async sendForm() {
            this.btnText = 'Sending...'
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/messages`,
                    data: this.contactData,
                    method: "POST",

                })
                this.btnText = 'Send Message'
                this.resetForm();
                this.$root.$refs.A.makeToast('success', resp.data.message)
            } catch (error) {
                this.btnText = 'Send Message'
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        resetForm() {
            this.contactData.sender_name = ''
            this.contactData.email = ''
            this.contactData.phone = ''
            this.contactData.subject = ''
            this.contactData.content = ''
        },
        onVerify: function (response) {
            if (response) {
                this.sendForm();
                this.$refs.recaptcha.reset()
            }
        },
        onExpired: function () {
            this.$refs.recaptcha.reset()
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset() // Direct call reset method
        },
    }
}
</script>

<style lang="scss" scoped>
.form-container {
    margin: 0 100px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0
    }
}

.btn-warning {
    padding: 10px 30px;
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.head-box {
    margin: 100px 100px 0 100px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 16px 16px 0px 0px;
    padding: 10px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 20px 0;
    }
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;
}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.float-right {
    float: right
}

textarea.form-control {
    height: 13.6rem !important;
}

.svg-inline--fa {
    height: 0.7em !important
}
</style>
